import InvoiceForm from "@app/components/forms/invoice/invoice-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_manager/invoice/$invoiceId/edit")({
    component: RouteComponent,
});

function RouteComponent() {
    const { invoiceId } = Route.useParams();

    return (
        <PageContainer title={"Update Invoice"} from={"/invoice"}>
            <InvoiceForm invoiceId={+invoiceId} />
        </PageContainer>
    );
}
